export enum LoraPacketType {
  Downlink = 'downlink',
  Uplink = 'uplink',
}
